import React from "react";

import useReportsTable from "@app/analytics/MeetingReports/stores/reportsTable";
import type { Report } from "@app/analytics/MeetingReports/types";

import EditTypography from "@rui/EditTypography";

const EditableReportTitle = ({
  report,
  maxWidth,
  onEditChange,
}: {
  report: Report;
  maxWidth: number;
  onEditChange: (title: string) => void;
}) => {
  const setEditReport = useReportsTable((state) => state.setEditReport);
  const handleToggleEdit = (isEditing: boolean) => {
    if (!isEditing) setEditReport(null);
  };

  return (
    <EditTypography
      id={`report-title-${report.id}`}
      editOn="mount"
      className="report-table-row__title"
      variant="bodySecondaryMed"
      value={report.title}
      floatingButtons
      onEditChange={onEditChange}
      onToggle={handleToggleEdit}
      maxWidth={maxWidth}
    />
  );
};

export default EditableReportTitle;
